import React, {Component} from 'react';
import Cta from './cta';

export default class Modal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible
        };
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
    }

    show() {
        this.setState({visible: true});
    }

    hide() {
        this.setState({visible: false});
    }

    render() {
        let _self = this;
        return <div className={"c-modal" + (this.state.visible ? '' : ' hide')}>
            <div className="c-modal-inner">
                <div className="c-modal-inner-header">
                    <h2>{this.props.title}</h2>
                    <i className="fas fa-times" onClick={() => {
                        _self.setState({visible: false});
                    }}></i>
                </div>
                <div className="c-modal-inner-content">
                    {this.props.children}
                </div>
                {!this.props.hideButtons &&
                <div className="c-modal-inner-buttons">
                    {this.props.cancel && <Cta text={this.props.cancel.text} light centered className="mr-3"
                                               click={this.props.cancel.click}/>}
                    {this.props.save && <Cta text={this.props.save.text} centered click={this.props.save.click}/>}
                </div>}
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/base/modal.js